import React from "react";
import doctorImage from "../../assets/images/Home/dr-vibha.jpeg";
import { Link } from "react-router-dom";
const HeroSection = () => {
  // ===== COLOR THEME =====
  const COLORS = {
    // Main Brand Colors (Logo se liye gaye)
    primary: "#546E7A", // Dark Slate Blue (Main Text & Outer Rings)
    secondary: "#D7A19E", // Muted Rose (Lady Silhouette - Feminine touch)
    accent: "#9BB2A3", // Sage Green (Healing & Nature)
    highlight: "#C5B358", // Muted Gold (Success & Positivity)

    // Neutral Colors (Clean UI ke liye)
    white: "#FFFFFF", // Pure White (Background)
    textDark: "#546E7A", // Logo ka dark shade text ke liye best hai
    textLight: "#9BB2A3", // Greenish grey sub-text ke liye
    divider: "#E5E7EB", // Light Gray (Sections alag karne ke liye)
  };

  return (
    <section
      className="min-h-screen flex items-center justify-center px-6 md:px-16 lg:px-24 py-16"
      style={{ backgroundColor: COLORS.bgSection }}
    >
      {/* Premium Card Container */}
      <div
        className="w-full max-w-7xl shadow-2xl p-8 md:p-14 lg:p-20 flex flex-col lg:flex-row items-center gap-12"
        style={{
          backgroundColor: COLORS.white,
          border: `1px solid ${COLORS.cardBorder}`,
        }}
      >
        {/* LEFT CONTENT */}
        <div className="flex-1 text-center lg:text-justify">
          <p
            className="uppercase tracking-[0.3em] text-xs font-semibold ml-2 mb-4"
            style={{ color: COLORS.primary }}
          >
            Compassionate • Advanced • Trusted
          </p>

          <h1
            className="text-4xl md:text-5xl lg:text-6xl  font-light leading-tight mb-6"
            style={{ color: COLORS.dark }}
          >
            Gynecology & <br />
            <span style={{ color: COLORS.primary }} className="">
              Fertility
            </span>
          </h1>

          <div
            className="w-16 h-[1px] mb-8 mx-auto lg:mx-0"
            style={{ backgroundColor: COLORS.divider }}
          ></div>

          <p
            className="mb-10 max-w-llg leading-relaxed text-justify"
            style={{ color: COLORS.textGray }}
          >
            We understand that the journey to parenthood is deeply personal.
            Every individual and every family carries a unique story and hope.
            Through compassionate consultation, we listen, guide, and support
            you. Our advanced fertility treatments are designed with precision
            and care. We combine medical expertise with a deeply human approach
            to healing. From diagnosis to recovery, every step is handled with
            sensitivity. We believe in creating a comfortable and trusting
            environment for you. With us, you are never alone — we walk with you
            at every step.
          </p>

          <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-6">
            <Link to="/about-us">
              <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-6 group">
                <Link to="/about-us">
                  <button
                    className={`px-8 py-3 uppercase font-bold tracking-widest text-xs rounded-xl transition duration-300
                 border-2 border-transparent text-white bg-[${COLORS.primary}]
                 group-hover:text-black group-hover:bg-white group-hover:border-black`}
                  >
                    Read More
                  </button>
                </Link>
              </div>
            </Link>
          </div>
        </div>

        {/* RIGHT IMAGE SECTION */}
        <div className="flex-1 flex flex-col items-center">
          <div className="relative">
            {/* Decorative Border Frame */}
            <div
              className="absolute -top-4 -right-4 w-full h-full hidden lg:block"
              style={{ border: `1px solid ${COLORS.cardBorder}` }}
            ></div>

            <img
              src={doctorImage}
              alt="Doctor"
              className="w-full max-w-md h-[420px] object-cover shadow-xl"
            />
          </div>

          <div className="mt-8 text-center">
            <h3
              className="font-serif text-xl font-light"
              style={{ color: COLORS.dark }}
            >
              Dr. Vibha Singh
            </h3>

            <p
              className="text-[11px] uppercase tracking-[0.25em] font-semibold mt-3"
              style={{ color: COLORS.primary }}
            >
              Obstetrics, Gynecology
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
